/* BikeLink – runde 9: faner for tekniske detaljer på produktsiden (desktop ≥ 1000 px).
   Progressiv forbedring: uten JS, og på mobil, er det trekkspill + snarveier som før. */
(function () {
  var mq = window.matchMedia('(min-width: 1000px)');
  function setup(root) {
    root.querySelectorAll('.bikelink-details').forEach(function (wrap) {
      var nav = wrap.querySelector('.bikelink-details__nav');
      if (!nav || nav.dataset.blTabs) return;
      var pills = Array.prototype.slice.call(nav.querySelectorAll('a.bikelink-details__pill'));
      var panels = pills.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      if (pills.length < 2 || panels.some(function (p) { return !p; })) return;
      nav.dataset.blTabs = '1';
      var current = 0;
      function select(i, focus) {
        current = i;
        pills.forEach(function (a, j) {
          var on = j === i;
          a.setAttribute('aria-selected', on ? 'true' : 'false');
          a.setAttribute('tabindex', on ? '0' : '-1');
          panels[j].hidden = !on;
          if (on) {
            var d = panels[j].querySelector(':scope > accordion-disclosure > details');
            if (d && !d.open) { d.open = true; d.setAttribute('aria-expanded', 'true'); }
          }
        });
        if (focus) pills[i].focus();
      }
      function enable() {
        wrap.classList.add('bl-tabs-on');
        nav.setAttribute('role', 'tablist');
        pills.forEach(function (a, j) {
          var id = a.id || ('bl-tab-' + Math.random().toString(36).slice(2, 8));
          a.id = id;
          a.setAttribute('role', 'tab');
          a.setAttribute('aria-controls', panels[j].id);
          panels[j].setAttribute('role', 'tabpanel');
          panels[j].setAttribute('aria-labelledby', id);
        });
        select(current);
      }
      function disable() {
        wrap.classList.remove('bl-tabs-on');
        nav.removeAttribute('role');
        pills.forEach(function (a, j) {
          ['role', 'aria-selected', 'aria-controls', 'tabindex'].forEach(function (k) { a.removeAttribute(k); });
          panels[j].hidden = false;
          panels[j].removeAttribute('role');
          panels[j].removeAttribute('aria-labelledby');
        });
      }
      nav.addEventListener('click', function (e) {
        var a = e.target.closest('a.bikelink-details__pill');
        if (!a || !wrap.classList.contains('bl-tabs-on')) return;
        e.preventDefault();
        select(pills.indexOf(a));
      });
      nav.addEventListener('keydown', function (e) {
        if (!wrap.classList.contains('bl-tabs-on')) return;
        var k = e.key, n = pills.length;
        if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
          e.preventDefault();
          var i = k === 'Home' ? 0 : k === 'End' ? n - 1 : (current + (k === 'ArrowRight' ? 1 : -1) + n) % n;
          select(i, true);
        }
      });
      // Lenker til #finn-storrelse / #bl-… fra kjøpsboksen skal åpne riktig fane
      document.addEventListener('click', function (e) {
        var l = e.target.closest('a[href="#finn-storrelse"], a[href^="#bl-"]');
        if (!l || nav.contains(l) || !wrap.classList.contains('bl-tabs-on')) return;
        var target = document.getElementById(l.getAttribute('href').slice(1));
        var idx = panels.findIndex(function (p) { return p === target || (target && p.contains(target)); });
        if (idx > -1) select(idx);
      });
      function apply() { mq.matches ? enable() : disable(); }
      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply);
      if (location.hash === '#finn-storrelse') {
        var t = document.getElementById('finn-storrelse');
        var idx = panels.findIndex(function (p) { return t && p.contains(t); });
        if (idx > -1 && mq.matches) select(idx);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(document); });
  else setup(document);
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
